module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Temperature graph","subTitle":"Trend of the temperature detected in the last 24 hours by the selected sensor."},"it":{"title":"Grafico della temperatura","subTitle":"Andamento della temperatura rilevata nelle ultime 24 ore  dal sensore selezionato."}}')
  delete Component.options._Ctor
}
